<h1 class="centrarTexto"> {{'old-browser.title' | translate}}</h1>

<img src="assets/img/old_browser.jpg" alt="{{'old-browser.alt-img' | translate}}" class="imagen">

<p class="centrarTexto"> {{'old-browser.p1' | translate}}</p>
<p class="centrarTexto"> {{'old-browser.p2' | translate}}</p>